export const generateVideoPageTranslations = {
    ru: {
        title: "Сгенерировать видео",
        description: "Создайте уникальное видео на основе ваших идей",
        audioFile: "Выберите аудиофайл, максимум 6 минут",
        selectFile: "Выберите файл",
        fileNotSelected: "Файл не выбран",
        fileSelected: "Файл выбран",
        generationMethod: "Способ генерации видео",
        methodSong: "Сгенерировать видео на основе песни и описания",
        methodPhotos: "Создать видео из ваших фото",
        selectPhotos: "Выберите фотографии",
        photosNotSelected: "Фотографии не выбраны",
        photosSelected: "Фотографии выбраны",
        photosCount: "Выбрано фотографий",
        descriptionLabel: "Описание",
        descriptionPlaceholder: "Опишите, какое видео вы хотите создать",
        videoStyle: "Стиль видео",
        videoStylePlaceholder: "Выберите стиль",
        verticalVideo: "Вертикальное видео",
        addTitle: "Добавить заголовок к видео",
        titlePlaceholder: "Введите заголовок",
        addCredits: "Добавить финальные титры в видео",
        creditsPlaceholder: "Ваши пожелания, от кого поздравление и т. д.",
        submit: "Сгенерировать видео",
        required: "Обязательное поле",
        videoStyles: {
            film: "Фильм",
            animation: "Анимация",
            documentary: "Документальный",
            musicVideo: "Клип",
            presentation: "Презентация",
            slideshow: "Слайдшоу",
            cinematic: "Кинематографический",
            vintage: "Винтаж",
        },
    },
    en: {
        title: "Generate Video",
        description: "Create a unique video based on your ideas",
        audioFile: "Select audio file, maximum 6 minutes",
        selectFile: "Select file",
        fileNotSelected: "File not selected",
        fileSelected: "File selected",
        generationMethod: "Video generation method",
        methodSong: "Generate video based on song and description",
        methodPhotos: "Create video from your photos",
        selectPhotos: "Select photos",
        photosNotSelected: "Photos not selected",
        photosSelected: "Photos selected",
        photosCount: "Photos selected",
        descriptionLabel: "Description",
        descriptionPlaceholder: "Describe what kind of video you want to create",
        videoStyle: "Video style",
        videoStylePlaceholder: "Select style",
        verticalVideo: "Vertical video",
        addTitle: "Add title to video",
        titlePlaceholder: "Enter title",
        addCredits: "Add final credits to video",
        creditsPlaceholder: "Your wishes, from whom the greeting, etc.",
        submit: "Generate video",
        required: "Required field",
        videoStyles: {
            film: "Film",
            animation: "Animation",
            documentary: "Documentary",
            musicVideo: "Music Video",
            presentation: "Presentation",
            slideshow: "Slideshow",
            cinematic: "Cinematic",
            vintage: "Vintage",
        },
    },
};
export const generatePoemPageTranslations = {
    ru: {
        title: "Сгенерировать стихи",
        description: "Создайте красивые стихи на любую тему",
        aboutPerson: "О ком стихи",
        aboutPersonPlaceholder: "Опишите, о ком или о чем должны быть стихи",
        additionalInfo: "Дополнительная информация",
        additionalInfoPlaceholder: "Добавьте любую дополнительную информацию, которая поможет создать стихи",
        tags: "Теги",
        tagsPlaceholder: "Выберите подходящие теги",
        writingStyle: "Стиль написания",
        writingStylePlaceholder: "Выберите стиль написания",
        quality: "Качество",
        qualityPlaceholder: "Выберите качество",
        submit: "Сгенерировать стихи",
        required: "Обязательное поле",
        writingStyles: {
            classic: "Классический",
            modern: "Современный",
            freeVerse: "Верлибр",
            sonnet: "Сонет",
            haiku: "Хайку",
            ballad: "Баллада",
            ode: "Ода",
            elegy: "Элегия",
            limerick: "Лimerick",
            acrostic: "Акростих",
        },
        qualities: {
            low: "Низкое",
            medium: "Среднее",
            high: "Высокое",
            premium: "Премиум",
        },
        tagsOptions: {
            romantic: "Романтические",
            energetic: "Энергичные",
            melancholic: "Меланхоличные",
            happy: "Веселые",
            sad: "Грустные",
            inspirational: "Вдохновляющие",
            nature: "О природе",
            philosophical: "Философские",
            dramatic: "Драматические",
            nostalgic: "Ностальгические",
        },
    },
    en: {
        title: "Generate Poem",
        description: "Create beautiful poems on any topic",
        aboutPerson: "About whom",
        aboutPersonPlaceholder: "Describe who or what the poem should be about",
        additionalInfo: "Additional information",
        additionalInfoPlaceholder: "Add any additional information that will help create the poem",
        tags: "Tags",
        tagsPlaceholder: "Select appropriate tags",
        writingStyle: "Writing style",
        writingStylePlaceholder: "Select writing style",
        quality: "Quality",
        qualityPlaceholder: "Select quality",
        submit: "Generate poem",
        required: "Required field",
        writingStyles: {
            classic: "Classic",
            modern: "Modern",
            freeVerse: "Free Verse",
            sonnet: "Sonnet",
            haiku: "Haiku",
            ballad: "Ballad",
            ode: "Ode",
            elegy: "Elegy",
            limerick: "Limerick",
            acrostic: "Acrostic",
        },
        qualities: {
            low: "Low",
            medium: "Medium",
            high: "High",
            premium: "Premium",
        },
        tagsOptions: {
            romantic: "Romantic",
            energetic: "Energetic",
            melancholic: "Melancholic",
            happy: "Happy",
            sad: "Sad",
            inspirational: "Inspirational",
            nature: "Nature",
            philosophical: "Philosophical",
            dramatic: "Dramatic",
            nostalgic: "Nostalgic",
        },
    },
};
export const generateSongPageTranslations = {
    ru: {
        title: "Сгенерировать песню",
        description: "Создайте уникальную песню на основе вашего текста",
        generationMethod: "Способ генерации",
        methodDescription: "Сгенерировать песню по описанию",
        methodText: "Сгенерировать песню по тексту",
        songText: "Текст песни",
        songTextPlaceholder: "Введите текст песни, который нужно превратить в музыку",
        aboutPerson: "О ком песня",
        aboutPersonPlaceholder: "Опишите, о ком или о чем должна быть песня",
        additionalInfo: "Дополнительная информация",
        additionalInfoPlaceholder: "Добавьте любую дополнительную информацию, которая поможет создать песню",
        tags: "Теги",
        tagsPlaceholder: "Выберите подходящие теги",
        genre: "Жанр песни",
        genrePlaceholder: "Выберите жанр",
        quality: "Качество",
        qualityPlaceholder: "Выберите качество",
        submit: "Сгенерировать песню",
        required: "Обязательное поле",
        genres: {
            pop: "Поп",
            rock: "Рок",
            rap: "Рэп",
            country: "Кантри",
            jazz: "Джаз",
            blues: "Блюз",
            electronic: "Электронная",
            classical: "Классическая",
            folk: "Народная",
            rnb: "R&B",
        },
        qualities: {
            low: "Низкое",
            medium: "Среднее",
            high: "Высокое",
            premium: "Премиум",
        },
        tagsOptions: {
            romantic: "Романтическая",
            energetic: "Энергичная",
            melancholic: "Меланхоличная",
            happy: "Веселая",
            sad: "Грустная",
            inspirational: "Вдохновляющая",
            party: "Для вечеринки",
            chill: "Расслабляющая",
            dramatic: "Драматическая",
            nostalgic: "Ностальгическая",
        },
    },
    en: {
        title: "Generate Song",
        description: "Create a unique song based on your text",
        generationMethod: "Generation method",
        methodDescription: "Generate song from description",
        methodText: "Generate song from text",
        songText: "Song text",
        songTextPlaceholder: "Enter the song text to turn into music",
        aboutPerson: "About whom",
        aboutPersonPlaceholder: "Describe who or what the song should be about",
        additionalInfo: "Additional information",
        additionalInfoPlaceholder: "Add any additional information that will help create the song",
        tags: "Tags",
        tagsPlaceholder: "Select appropriate tags",
        genre: "Song genre",
        genrePlaceholder: "Select genre",
        quality: "Quality",
        qualityPlaceholder: "Select quality",
        submit: "Generate song",
        required: "Required field",
        genres: {
            pop: "Pop",
            rock: "Rock",
            rap: "Rap",
            country: "Country",
            jazz: "Jazz",
            blues: "Blues",
            electronic: "Electronic",
            classical: "Classical",
            folk: "Folk",
            rnb: "R&B",
        },
        qualities: {
            low: "Low",
            medium: "Medium",
            high: "High",
            premium: "Premium",
        },
        tagsOptions: {
            romantic: "Romantic",
            energetic: "Energetic",
            melancholic: "Melancholic",
            happy: "Happy",
            sad: "Sad",
            inspirational: "Inspirational",
            party: "Party",
            chill: "Chill",
            dramatic: "Dramatic",
            nostalgic: "Nostalgic",
        },
    },
};
export const generateGreetingsPageTranslations = {
    ru: {
        title: "Генерация поздравлений",
        description: "Создайте персональное поздравление для любого праздника",
        occasion: "Повод для поздравления",
        occasionPlaceholder: "Выберите повод",
        recipient: "Кому поздравление",
        recipientPlaceholder: "Опишите, кому предназначено поздравление",
        additionalInfo: "Дополнительная информация",
        additionalInfoPlaceholder: "Добавьте любую дополнительную информацию (возраст, интересы, отношения и т.д.)",
        tone: "Тон поздравления",
        tonePlaceholder: "Выберите тон",
        quality: "Качество",
        qualityPlaceholder: "Выберите качество",
        submit: "Сгенерировать поздравление",
        required: "Обязательное поле",
        occasions: {
            birthday: "День рождения",
            newYear: "Новый год",
            wedding: "Свадьба",
            anniversary: "Юбилей",
            graduation: "Выпускной",
            christmas: "Рождество",
            valentines: "День святого Валентина",
            mothersDay: "День матери",
            fathersDay: "День отца",
            other: "Другое",
        },
        tones: {
            formal: "Официальный",
            friendly: "Дружелюбный",
            humorous: "Юмористический",
            romantic: "Романтический",
            warm: "Теплый",
            inspiring: "Вдохновляющий",
            casual: "Неформальный",
        },
        qualities: {
            low: "Низкое",
            medium: "Среднее",
            high: "Высокое",
            premium: "Премиум",
        },
    },
    en: {
        title: "Generate Greetings",
        description: "Create a personal greeting for any occasion",
        occasion: "Occasion",
        occasionPlaceholder: "Select occasion",
        recipient: "Recipient",
        recipientPlaceholder: "Describe who the greeting is for",
        additionalInfo: "Additional information",
        additionalInfoPlaceholder: "Add any additional information (age, interests, relationship, etc.)",
        tone: "Tone",
        tonePlaceholder: "Select tone",
        quality: "Quality",
        qualityPlaceholder: "Select quality",
        submit: "Generate greeting",
        required: "Required field",
        occasions: {
            birthday: "Birthday",
            newYear: "New Year",
            wedding: "Wedding",
            anniversary: "Anniversary",
            graduation: "Graduation",
            christmas: "Christmas",
            valentines: "Valentine's Day",
            mothersDay: "Mother's Day",
            fathersDay: "Father's Day",
            other: "Other",
        },
        tones: {
            formal: "Formal",
            friendly: "Friendly",
            humorous: "Humorous",
            romantic: "Romantic",
            warm: "Warm",
            inspiring: "Inspiring",
            casual: "Casual",
        },
        qualities: {
            low: "Low",
            medium: "Medium",
            high: "High",
            premium: "Premium",
        },
    },
};
export const vocalRemovalPageTranslations = {
    ru: {
        title: "Удаление вокала",
        description: "Удалите вокал из аудиофайла с помощью искусственного интеллекта",
        audioFile: "Выберите аудиофайл",
        selectFile: "Выберите файл",
        fileNotSelected: "Файл не выбран",
        fileSelected: "Файл выбран",
        quality: "Качество обработки",
        qualityPlaceholder: "Выберите качество",
        submit: "Удалить вокал",
        required: "Обязательное поле",
        qualities: {
            low: "Низкое",
            medium: "Среднее",
            high: "Высокое",
            premium: "Премиум",
        },
        processing: "Обработка...",
        success: "Вокал успешно удален!",
        error: "Произошла ошибка при обработке",
    },
    en: {
        title: "Vocal Removal",
        description: "Remove vocals from audio file using artificial intelligence",
        audioFile: "Select audio file",
        selectFile: "Select file",
        fileNotSelected: "File not selected",
        fileSelected: "File selected",
        quality: "Processing quality",
        qualityPlaceholder: "Select quality",
        submit: "Remove vocals",
        required: "Required field",
        qualities: {
            low: "Low",
            medium: "Medium",
            high: "High",
            premium: "Premium",
        },
        processing: "Processing...",
        success: "Vocals removed successfully!",
        error: "An error occurred during processing",
    },
};
export const portraitGenerationPageTranslations = {
    ru: {
        title: "Генерация портрета",
        description: "Создайте уникальный портрет с помощью искусственного интеллекта",
        photoUpload: "Загрузите фото (опционально)",
        selectPhoto: "Выберите фото",
        photoNotSelected: "Фото не выбрано",
        photoSelected: "Фото выбрано",
        descriptionLabel: "Описание портрета",
        descriptionPlaceholder: "Опишите, какой портрет вы хотите создать",
        style: "Стиль портрета",
        stylePlaceholder: "Выберите стиль",
        portraitType: "Тип портрета",
        portraitTypePlaceholder: "Выберите тип",
        aspectRatio: "Соотношение сторон",
        aspectRatioPlaceholder: "Выберите соотношение сторон",
        textOnPortrait: "Текст на портрете",
        textOnPortraitPlaceholder: "Введите текст, который будет размещен на портрете (опционально)",
        quality: "Качество",
        qualityPlaceholder: "Выберите качество",
        submit: "Сгенерировать портрет",
        required: "Обязательное поле",
        styles: {
            realistic: "Реалистичный",
            artistic: "Художественный",
            cartoon: "Мультяшный",
            oilPainting: "Масляная живопись",
            watercolor: "Акварель",
            pencil: "Карандашный",
            digital: "Цифровой",
            vintage: "Винтажный",
        },
        portraitTypes: {
            female: "Женский",
            male: "Мужской",
        },
        aspectRatios: {
            "16:9": "16:9 (Горизонтальное)",
            "9:16": "9:16 (Вертикальное)",
            "1:1": "1:1 (Квадратное)",
            "4:3": "4:3 (Классическое)",
        },
        qualities: {
            low: "Низкое",
            medium: "Среднее",
            high: "Высокое",
            premium: "Премиум",
        },
    },
    en: {
        title: "Portrait Generation",
        description: "Create a unique portrait using artificial intelligence",
        photoUpload: "Upload photo (optional)",
        selectPhoto: "Select photo",
        photoNotSelected: "Photo not selected",
        photoSelected: "Photo selected",
        descriptionLabel: "Portrait description",
        descriptionPlaceholder: "Describe what kind of portrait you want to create",
        style: "Portrait style",
        stylePlaceholder: "Select style",
        portraitType: "Portrait type",
        portraitTypePlaceholder: "Select type",
        aspectRatio: "Aspect ratio",
        aspectRatioPlaceholder: "Select aspect ratio",
        textOnPortrait: "Text on portrait",
        textOnPortraitPlaceholder: "Enter text to be placed on the portrait (optional)",
        quality: "Quality",
        qualityPlaceholder: "Select quality",
        submit: "Generate portrait",
        required: "Required field",
        styles: {
            realistic: "Realistic",
            artistic: "Artistic",
            cartoon: "Cartoon",
            oilPainting: "Oil Painting",
            watercolor: "Watercolor",
            pencil: "Pencil",
            digital: "Digital",
            vintage: "Vintage",
        },
        portraitTypes: {
            female: "Female",
            male: "Male",
        },
        aspectRatios: {
            "16:9": "16:9 (Horizontal)",
            "9:16": "9:16 (Vertical)",
            "1:1": "1:1 (Square)",
            "4:3": "4:3 (Classic)",
        },
        qualities: {
            low: "Low",
            medium: "Medium",
            high: "High",
            premium: "Premium",
        },
    },
};
export const clipGenerationPageTranslations = {
    ru: {
        title: "Генерация клипов",
        description: "Создайте музыкальный клип с помощью искусственного интеллекта",
        audioFile: "Выберите аудиофайл",
        selectFile: "Выберите файл",
        fileNotSelected: "Файл не выбран",
        fileSelected: "Файл выбран",
        descriptionLabel: "Описание клипа",
        descriptionPlaceholder: "Опишите, какой клип вы хотите создать",
        clipStyle: "Стиль клипа",
        clipStylePlaceholder: "Выберите стиль",
        quality: "Качество",
        qualityPlaceholder: "Выберите качество",
        selectPhotos: "Выберите фотографии",
        photosNotSelected: "Фотографии не выбраны",
        photosSelected: "Фотографии выбраны",
        photosCount: "Выбрано фотографий",
        aspectRatio: "Соотношение сторон",
        aspectRatioPlaceholder: "Выберите соотношение сторон",
        duration: "Длительность клипа",
        durationPlaceholder: "Выберите длительность",
        submit: "Сгенерировать клип",
        required: "Обязательное поле",
        clipStyles: {
            energetic: "Энергичный",
            romantic: "Романтический",
            dramatic: "Драматический",
            fun: "Веселый",
            cinematic: "Кинематографический",
            abstract: "Абстрактный",
            nature: "Природный",
            urban: "Городской",
        },
        aspectRatios: {
            "16:9": "16:9 (Горизонтальное)",
            "9:16": "9:16 (Вертикальное)",
            "1:1": "1:1 (Квадратное)",
            "4:3": "4:3 (Классическое)",
        },
        durations: {
            "15": "15 секунд",
            "30": "30 секунд",
            "60": "1 минута",
            "90": "1.5 минуты",
            "120": "2 минуты",
            "180": "3 минуты",
        },
        qualities: {
            low: "Низкое",
            medium: "Среднее",
            high: "Высокое",
            premium: "Премиум",
        },
    },
    en: {
        title: "Clip Generation",
        description: "Create a music clip using artificial intelligence",
        audioFile: "Select audio file",
        selectFile: "Select file",
        fileNotSelected: "File not selected",
        fileSelected: "File selected",
        descriptionLabel: "Clip description",
        descriptionPlaceholder: "Describe what kind of clip you want to create",
        clipStyle: "Clip style",
        clipStylePlaceholder: "Select style",
        quality: "Quality",
        qualityPlaceholder: "Select quality",
        selectPhotos: "Select photos",
        photosNotSelected: "Photos not selected",
        photosSelected: "Photos selected",
        photosCount: "Photos selected",
        aspectRatio: "Aspect ratio",
        aspectRatioPlaceholder: "Select aspect ratio",
        duration: "Clip duration",
        durationPlaceholder: "Select duration",
        submit: "Generate clip",
        required: "Required field",
        clipStyles: {
            energetic: "Energetic",
            romantic: "Romantic",
            dramatic: "Dramatic",
            fun: "Fun",
            cinematic: "Cinematic",
            abstract: "Abstract",
            nature: "Nature",
            urban: "Urban",
        },
        aspectRatios: {
            "16:9": "16:9 (Horizontal)",
            "9:16": "9:16 (Vertical)",
            "1:1": "1:1 (Square)",
            "4:3": "4:3 (Classic)",
        },
        durations: {
            "15": "15 seconds",
            "30": "30 seconds",
            "60": "1 minute",
            "90": "1.5 minutes",
            "120": "2 minutes",
            "180": "3 minutes",
        },
        qualities: {
            low: "Low",
            medium: "Medium",
            high: "High",
            premium: "Premium",
        },
    },
};
